import type {
  Environment,
  Territory,
} from "$global-providers/config-provider/provider";

const SYNTHETIC_DEMO_STUDY_IDS: Partial<
  Record<`${Territory}-${Environment}`, readonly string[]>
> = {
  "nigeria-acceptance": [
    "cmrt1lf8a000hb801kf6vxyct",
    "cmrt1lgu9000ob801lkjcdw4f",
    "cmrt1lib3000vb801hsd1n9u9",
    "cmrt1ljtn0012b801bhab18qr",
    "cmrt1lldu0019b801pozcvy0l",
  ],
  "nigeria-production": [
    "cmshg6z2h0025ad01ohqbop0r",
    "cmshg6zso002cad0112dlplau",
    "cmshg70j5002jad01u6nicigs",
    "cmshg71dr001v9c0168dw3k1k",
    "cmshg724300229c0110c33gi6",
  ],
};

export const demoStudyPool = (
  territory: Territory,
  environment: Environment,
): readonly string[] =>
  SYNTHETIC_DEMO_STUDY_IDS[`${territory}-${environment}`] ?? [];
